import React, { FC, useEffect } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Button, Stack } from '@mui/material';

import {
  MIN_LONG,
  IS_REQUIRED,
  NEED_VALID_EMAIL,
  MUST_BE_LATIN_LETTER,
} from '../../../helpers/constants';
import { Input } from '../../../components/Input';
import { CustomModal } from '../../../components/CustomModal';
import { GetUsersDocument } from '../../../graphql/query/__generated__/getUsers';
import { useCreateUserMutation } from '../../../graphql/mutations/__generated__/addUser';

interface Props {
  closeModal(): void;
}
enum AddClientFields {
  city = 'city',
  email = 'email',
  company = 'company',
  username = 'username',
  password = 'password',
}

const initialValues = {
  [AddClientFields.city]: '',
  [AddClientFields.email]: '',
  [AddClientFields.company]: '',
  [AddClientFields.username]: '',
  [AddClientFields.password]: '',
};
const validationSchema = yup.object({
  [AddClientFields.city]: yup.string(),
  [AddClientFields.company]: yup.string().required(IS_REQUIRED),
  [AddClientFields.username]: yup.string().required(IS_REQUIRED),
  [AddClientFields.email]: yup.string().email(NEED_VALID_EMAIL).required(IS_REQUIRED),
  [AddClientFields.password]: yup
    .string()
    .min(8, MIN_LONG)
    .matches(/[a-zA-Z]/, MUST_BE_LATIN_LETTER)
    .required(IS_REQUIRED),
});

export const AddUserModal: FC<Props> = ({ closeModal }) => {
  const [runAddUser] = useCreateUserMutation();
  const myFunc = () => {
    return console.log('2');
  };

  const { values, errors, touched, handleChange, setErrors, handleSubmit } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async values => {
      try {
        const response = await runAddUser({
          variables: {
            city: values.city,
            email: values.email,
            name: values.username,
            company: values.company,
            password: values.password,
          },
          refetchQueries: [
            {
              query: GetUsersDocument,
              variables: { current: false },
            },
          ],
        });
        if (response?.data) {
          closeModal();
        }
      } catch (error: any) {
        setErrors({
          [AddClientFields.email]: error.graphQLErrors[0].debugMessage,
        });
        console.error('[ERROR_GRAPHQL]:', error.graphQLErrors[0]);
      }
    },
  });

  useEffect(() => {
    console.log('1');
    return () => console.log('4');
  }, [myFunc]);

  return (
    <CustomModal title="Добавить пользователя" handleClose={closeModal} open={true}>
      <Stack component="form" flexGrow={1} spacing={2} onSubmit={handleSubmit}>
        <Input
          type="name"
          label="Имя"
          placeholder={'Имя'}
          onChange={handleChange}
          name={AddClientFields.username}
          value={values[AddClientFields.username]}
          error={touched[AddClientFields.username] && !!errors[AddClientFields.username]}
          helperText={touched[AddClientFields.username] && errors[AddClientFields.username]}
        />

        <Input
          type="city"
          label="Город"
          placeholder={'Город'}
          onChange={handleChange}
          name={AddClientFields.city}
          value={values[AddClientFields.city]}
          error={touched[AddClientFields.city] && !!errors[AddClientFields.city]}
          helperText={touched[AddClientFields.city] && errors[AddClientFields.city]}
        />

        <Input
          type="company"
          label="Компания"
          placeholder={'Компания'}
          onChange={handleChange}
          name={AddClientFields.company}
          value={values[AddClientFields.company]}
          error={touched[AddClientFields.company] && !!errors[AddClientFields.company]}
          helperText={touched[AddClientFields.company] && errors[AddClientFields.company]}
        />

        <Input
          type="email"
          label="email"
          placeholder={'email'}
          onChange={handleChange}
          name={AddClientFields.email}
          value={values[AddClientFields.email]}
          error={touched[AddClientFields.email] && !!errors[AddClientFields.email]}
          helperText={touched[AddClientFields.email] && errors[AddClientFields.email]}
        />

        <Input
          type="password"
          label="Пароль"
          onChange={handleChange}
          placeholder={'Пароль'}
          name={AddClientFields.password}
          value={values[AddClientFields.password]}
          error={touched[AddClientFields.password] && !!errors[AddClientFields.password]}
          helperText={touched[AddClientFields.password] && errors[AddClientFields.password]}
        />

        <Button color="secondary" variant="contained" size="large" type="submit">
          Добавить пользователя
        </Button>
      </Stack>
    </CustomModal>
  );
};
